// removed by extract-text-webpack-plugin
module.exports = {"already-have-account":"src-components-SignUp-___SetUpCredentials__already-have-account___uKjsK","third-party-auth":"src-components-SignUp-___SetUpCredentials__third-party-auth___FA9SX","link":"src-components-SignUp-___SetUpCredentials__link___q25CZ","spaceBetweenFormGroups":"src-components-SignUp-___SetUpCredentials__spaceBetweenFormGroups___2BTSd","submitButtonContainer":"src-components-SignUp-___SetUpCredentials__submitButtonContainer___dpdij","errorText":"src-components-SignUp-___SetUpCredentials__errorText____ZlPl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SignUp/SetUpCredentials.css
// module id = 953
// module chunks = 3